"use client";
import { useState, useEffect } from "react";
import "./Home.css";
import APP_CONFIG from "./Config";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import MobileDetect from "mobile-detect";
import { Helmet } from 'react-helmet-async';

export default function HomePage() {
  const navigate = useNavigate();
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [products,setProducts] = useState([]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
        }
      );
    } else {
    }
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const now = new Date();
    const formattedDate = now.toISOString(); 
    const data = {
      name: formData.name,
      email: formData.email,
      subject: formData.subject,
      message: formData.message,
      formattedDate: formattedDate,
    };

    try {
      const response = await fetch(APP_CONFIG.BACKEND_URL+'feedback', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      if (response.ok) {
        const result = await response.text(); 
        toast.success(result || "Feedback Submitted successfully!");
        setFormData({
          name: "",
          email:"",
          subject: "",
          message: "",
        });
      } else {
        const errorText = await response.text();
        toast.error(`Failed to send feedback: ${errorText}`);
      }
    } catch (error) {
      toast.error(`Network error: ${error.message}`);
    }
   



  };

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const handleLogin = async (event) => {
    event.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[0-9]{10}$/;

    if (!emailRegex.test(email) && !mobileRegex.test(email)) {
      toast.error("Please enter a valid email or 10-digit mobile number.");
      return;
    }
    if (!email) {
      toast.error("Please enter your Email or Mobile number.");
      return;
    }
    if (!password) {
      toast.error("Please enter your Password.");
      return;
    } else {
      let Login_Date_Time = new Date().toISOString();

      // Fetching Mobile or PC
      const md = new MobileDetect(window.navigator.userAgent);
      const deviceType = md.mobile() ? "Mobile" : "PC";

      try {
        const response = await fetch(APP_CONFIG.BACKEND_URL+'login', {
          method: "POST",
          body: JSON.stringify({
            email,
            password,
            deviceType,
            latitude,
            longitude,
            Login_Date_Time,
          }),
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (data.status === "success") {
          Cookies.set("token", data.token, {
            expires: 7 / 24,
            // expires: 1 / 1440,
            secure: true,
            sameSite: "Strict",
          });
          // localStorage.setItem("token", data.token);
          Cookies.set("customerName", data.customerName, {
            expires: 7 / 24,
            // expires: 1 / 1440,
            secure: true,
            sameSite: "Strict",
          });
          toast.success("Login Successful!");

          const productsResponse = await fetch(APP_CONFIG.BACKEND_URL + "products", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });
          if (productsResponse.ok) {
            const productsData = await productsResponse.json();
            const filteredProducts = productsData.products.filter(product => data.productIds.includes(product.productId));
            setProducts(filteredProducts);
            localStorage.setItem('userProducts', JSON.stringify(filteredProducts));
          } else {
            const errorText = await productsResponse.text();
          }

          navigate("/home");
        } else {
          toast.error("Invalid credentials. Please try again.");
        }
      } catch (error) {
        toast.error(`Request failed: ${error.message}`);
      }
    }
  };

  return (
    <>

<Helmet>
        <title>Learn ProwessERP </title>
        <meta
          name="description"
          content="Learn ProwessERP is your one-stop e-learning platform offering video tutorials and training across various products, including ERP and more."
        />
        <meta name="keywords" content="ERP, ProwessERP, Learn ERP, ERP Projects, Client Portal, IIPL" />
        <meta name="author" content="ProwessERP" />
        <meta property="og:title" content="Learn ProwessERP" />
        <meta property="og:description" content="Watch learning videos, explore product trainings, and access tutorials at ProwessERP’s all-in-one learning platform." />
        <meta property="og:url" content="https://learn.prowesserp.com/" />
        <meta property="og:type" content="website" />
        
        <link rel="canonical" href="https://learn.prowesserp.com/" />
      </Helmet>

    <div className="company-homepage">
      <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm">
        <div className="container">
          <a
            href="https://prowesserp.com/"
            className="navbar-brand d-flex align-items-center"
          >
            <span className="ms-2 h4 mb-0 text-primary fw-bold">
              <img src="./prowess-logo.png" alt="Prowss Erp Logo" />
            </span>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            onClick={handleNavCollapse}
            aria-expanded={!isNavCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse`}
          >
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a href="#about" className="nav-link">
                  About
                </a>
              </li>
              <li className="nav-item">
                <a href="#advantages" className="nav-link">
                  Advantages
                </a>
              </li>
              <li className="nav-item">
                <a href="#gallery" className="nav-link">
                  Gallery
                </a>
              </li>
              <li className="nav-item">
                <a href="#contact" className="nav-link">
                  Contact
                </a>
              </li>
              <li className="nav-item ms-lg-3">
                <a href="#portal" className="btn btn-primary rounded-pill px-4">
                  Login to Portal
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section
        className="hero py-5 bg-light d-flex align-items-center"
        style={{ minHeight: "100vh", paddingTop: "76px" }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-lg-6 mb-5 mb-lg-0"
              style={{ marginTop: "3rem" }}
            >
              <h1 className="display-4 fw-bold mb-4">
                Transforming Ideas Into Digital Reality
              </h1>
              <p className="lead mb-4">
                We help businesses grow by providing innovative solutions
                tailored to their unique needs. Our team of experts is dedicated
                to delivering excellence.
              </p>
              <div className="d-flex gap-3">
                <a
                  href="#about"
                  className="btn btn-primary btn-lg rounded-pill px-4"
                >
                  Learn More
                </a>
                <a
                  href="#contact"
                  className="btn btn-outline-secondary btn-lg rounded-pill px-4"
                >
                  Contact Us
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="position-relative">
                <img
                  src="/wp2.webp?height=600&width=800"
                  width={800}
                  height={600}
                  alt="Business team working together"
                  className="img-fluid rounded-4 shadow"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-5 bg-white">
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src="/wp1.webp?height=600&width=800"
                width={800}
                height={600}
                alt="Our office"
                className="img-fluid rounded-4 shadow"
              />
            </div>
            <div className="col-lg-6 ps-lg-5 d-flex flex-column justify-content-center">
              <div className="mb-4">
                <span className="badge bg-primary-subtle text-primary mb-2 p-2">
                  About Us
                </span>
                <h2 className="display-5 fw-bold mb-4">
                  We've Been Crafting Digital Experiences Since 2005
                </h2>
                <p className="lead">
                  INNOVATIVE was founded in 2005 by a group of technology
                  professionals with shared values and the shared objective of
                  offering world class IT solutions to a global clientele.
                </p>
              </div>
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <div className="bg-primary-subtle p-3 rounded-3 me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="bi bi-people text-primary"
                        viewBox="0 0 16 16"
                      >
                        <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" />
                      </svg>
                    </div>
                    <div>
                      <h5 className="mb-1">Expert Team</h5>
                      <p className="mb-0 text-muted">Skilled professionals</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <div className="bg-primary-subtle p-3 rounded-3 me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="bi bi-graph-up-arrow text-primary"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h5 className="mb-1">Growth Focus</h5>
                      <p className="mb-0 text-muted">Results-driven approach</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section id="advantages" className="py-5 bg-light">
        <div className="container py-5">
          <div className="text-center mb-5">
            <span className="badge bg-primary-subtle text-primary mb-2 p-2">
              Our Advantages
            </span>
            <h2 className="display-5 fw-bold mb-3">Why Choose Us</h2>
            <p className="lead mx-auto" style={{ maxWidth: "700px" }}>
              We combine industry expertise, cutting-edge technology, and
              personalized service to deliver exceptional results for our
              clients.
            </p>
          </div>
          <div className="row g-4">
            <div className="col-md-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div className="bg-primary-subtle p-3 rounded-3 mb-3 d-inline-block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      className="bi bi-lightning-charge text-primary"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09zM4.157 8.5H7a.5.5 0 0 1 .478.647L6.11 13.59l5.732-6.09H9a.5.5 0 0 1-.478-.647L9.89 2.41 4.157 8.5z" />
                    </svg>
                  </div>
                  <h4 className="mb-3">Fast Delivery</h4>
                  <p className="text-muted mb-0">
                    We deliver projects on time without compromising on quality,
                    ensuring your business stays ahead of the competition.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div className="bg-primary-subtle p-3 rounded-3 mb-3 d-inline-block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      className="bi bi-shield-check text-primary"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                      <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                    </svg>
                  </div>
                  <h4 className="mb-3">Secure Solutions</h4>
                  <p className="text-muted mb-0">
                    Security is at the core of everything we build, protecting
                    your data and your customers' information.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div className="bg-primary-subtle p-3 rounded-3 mb-3 d-inline-block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      className="bi bi-gear text-primary"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                      <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
                    </svg>
                  </div>
                  <h4 className="mb-3">Customizable</h4>
                  <p className="text-muted mb-0">
                    We tailor our solutions to meet your specific requirements,
                    ensuring a perfect fit for your business needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div className="bg-primary-subtle p-3 rounded-3 mb-3 d-inline-block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      className="bi bi-headset text-primary"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z" />
                    </svg>
                  </div>
                  <h4 className="mb-3">24/7 Support</h4>
                  <p className="text-muted mb-0">
                    Our dedicated support team is available around the clock to
                    address any issues or questions you may have.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-5 bg-white">
        <div className="container py-5">
          <div className="text-center mb-5">
            <span className="badge bg-primary-subtle text-primary mb-2 p-2">
              Our Gallery
            </span>
            <h2 className="display-5 fw-bold mb-3">See Our Work</h2>
            <p className="lead mx-auto" style={{ maxWidth: "700px" }}>
              Browse through our portfolio of successful projects and see how
              we've helped businesses transform their digital presence.
            </p>
          </div>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div
                className="card border-0 shadow-sm overflow-hidden"
                style={{ height: "100%" }}
              >
                <img
                  src="/wp3.webp?height=400&width=600"
                  width={600}
                  height={400}
                  alt="Project 1"
                  className="img-fluid"
                  style={{ height: "400px", objectFit: "cover" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title">E-commerce Platform</h5>
                  <p className="card-text text-muted">
                    A custom e-commerce solution for a retail client that
                    increased online sales by 200%.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div
                className="card border-0 shadow-sm overflow-hidden"
                style={{ height: "100%" }}
              >
                <img
                  src="/wp4.png?height=400&width=600"
                  width={600}
                  height={400}
                  alt="Project 2"
                  className="img-fluid"
                  style={{ height: "400px", objectFit: "cover" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title">Application Development</h5>
                  <p className="card-text text-muted">
                    A secure and user-friendly application development solution
                    for a leading financial institution.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div
                className="card border-0 shadow-sm overflow-hidden"
                style={{ height: "100%" }}
              >
                <img
                  src="/wp5.jpg?height=400&width=600"
                  width={600}
                  height={400}
                  alt="Project 3"
                  className="img-fluid"
                  style={{ height: "400px", objectFit: "cover" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title">Business intelligence</h5>
                  <p className="card-text text-muted">
                    A secure and user-friendly Business Intelligence application
                    for a leading financial institution.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-5">
            <a className="btn btn-outline-primary rounded-pill px-4">
              And many More
            </a>
          </div>
        </div>
      </section>

      <section id="portal" className="py-5 bg-light">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <div className="pe-lg-5">
                <span className="badge bg-primary-subtle text-primary mb-2 p-2">
                  Employee Training
                </span>
                <h2 className="display-5 fw-bold mb-4">
                  Access Your Learning Portal
                </h2>
                <p className="lead mb-4">
                  Our comprehensive training platform helps you develop new
                  skills, stay updated with industry trends, and advance your
                  career with IIPL Training.
                </p>
                <div className="d-flex flex-column gap-4">
                  <div className="d-flex align-items-center">
                    <div className="bg-primary-subtle p-3 rounded-3 me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="bi bi-book text-primary"
                        viewBox="0 0 16 16"
                      >
                        <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z" />
                      </svg>
                    </div>
                    <div>
                      <h5 className="mb-1">25+ Courses</h5>
                      <p className="mb-0 text-muted">
                        Access a wide range of professional development courses
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="bg-primary-subtle p-3 rounded-3 me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="bi bi-trophy text-primary"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935zM3.504 1c.007.517.026 1.006.056 1.469.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.501.501 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667.03-.463.049-.952.056-1.469H3.504z" />
                      </svg>
                    </div>
                    <div>
                      <h5 className="mb-1">Certifications</h5>
                      <p className="mb-0 text-muted">
                        Earn industry-recognized certifications
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="bg-primary-subtle p-3 rounded-3 me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="bi bi-graph-up-arrow text-primary"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h5 className="mb-1">Track Progress</h5>
                      <p className="mb-0 text-muted">
                        Monitor your learning journey with detailed analytics
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card border-0 shadow-lg rounded-4">
                <div className="card-body p-5">
                  <h3 className="card-title text-center mb-4">
                    Learning Portal Login
                  </h3>
                  <form>
                    <div className="mb-4">
                      <label htmlFor="email" className="form-label">
                        Email or Mobile Number
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control form-control-lg"
                        id="email"
                        placeholder="Enter your email or mobile number"
                        autoComplete="username"
                      />
                    </div>
                    <div className="mb-4">
                      <div className="password-label">
                        <label htmlFor="password">Password</label>
                        <a href="#" className="text-decoration-none">
                          Forgot password?
                        </a>
                      </div>
                      <div className="password-input-container">
                        <input
                          type={showPassword ? "text" : "password"}
                          onChange={(e) => setPassword(e.target.value)}
                          value={password}
                          className="form-control form-control-lg"
                          id="password"
                          placeholder="Enter your password"
                          autoComplete="current-password"
                        />
                        <button
                          type="button"
                          className="password-toggle"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                              <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                              <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                              <line x1="2" x2="22" y1="2" y2="22"></line>
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                              <circle cx="12" cy="12" r="3"></circle>
                            </svg>
                          )}
                        </button>
                      </div>
                    </div>
                    {/* <div className="mb-4 form-check">
                      <input type="checkbox" className="form-check-input" id="rememberMe" />
                      <label className="form-check-label" htmlFor="rememberMe">
                        Remember me
                      </label>
                    </div> */}
                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg"
                        onClick={handleLogin}
                      >
                        Login to Portal
                      </button>
                    </div>
                    <div className="text-center mt-4">
                      <p className="mt-3 mb-0 text-muted">
                        New employee?{" "}
                        <a className="text-decoration-none">Contact HR</a> for
                        access
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-5 bg-white">
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <span className="badge bg-primary-subtle text-primary mb-2 p-2">
                Contact Us
              </span>
              <h2 className="display-5 fw-bold mb-4">Get In Touch</h2>
              <p className="lead mb-5">
                Have questions or ready to start your project? Reach out to us
                using the contact form or through our contact information.
              </p>
              <div className="d-flex align-items-center mb-4">
                <div className="bg-primary-subtle p-3 rounded-3 me-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-geo-alt text-primary"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                  </svg>
                </div>
                <div>
                  <h5 className="mb-1">Address</h5>
                  <p className="mb-0">
                    CBD Belapur, Platform Level, G004, Tower No.2, Belapur
                    Railway Station Commercial Complex, Sector 11, CBD Belapur,
                    Navi Mumbai, Thane, Maharashtra, 400614
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-4">
                <div className="bg-primary-subtle p-3 rounded-3 me-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-envelope text-primary"
                    viewBox="0 0 16 16"
                  >
                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                  </svg>
                </div>
                <div>
                  <h5 className="mb-1">Email</h5>
                  <p className="mb-0">solution@infoinnovative.com</p>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="bg-primary-subtle p-3 rounded-3 me-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-telephone text-primary"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                  </svg>
                </div>
                <div>
                  <h5 className="mb-1">Phone</h5>
                  <p className="mb-0">+91 22-40160521</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-5">
                  <form onSubmit={handleFormSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label htmlFor="name" className="form-label">
                          Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Your name"
                          value={formData.name}
                          onChange={handleFormChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="email" className="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Your email"
                          value={formData.email}
                          onChange={handleFormChange}
                          required
                        />
                      </div>
                      <div className="col-12">
                        <label htmlFor="subject" className="form-label">
                          Subject
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="subject"
                          placeholder="Subject"
                          value={formData.subject}
                          onChange={handleFormChange}
                          required
                        />
                      </div>
                      <div className="col-12">
                        <label htmlFor="message" className="form-label">
                          Message
                        </label>
                        <textarea
                          className="form-control"
                          id="message"
                          rows="5"
                          placeholder="Your message"
                          value={formData.message}
                          onChange={handleFormChange}
                          required
                        ></textarea>
                      </div>
                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-primary rounded-pill px-4"
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-white py-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-4">
              <a
                href="https://infoinnovative.com/"
                target="_blank"
                className="d-inline-block mb-3"
              >
                <span className="h3 text-white fw-bold">
                  <img src="./prowess-logo-white.png" alt="Prowess Erp Logo" />
                </span>
              </a>
              <p className="mb-4">
                Transforming businesses through innovative digital solutions
                since 2005.
              </p>
              <div className="d-flex gap-3">
                <a className="text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-facebook"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                  </svg>
                </a>
                <a className="text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-twitter"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                  </svg>
                </a>
                <a className="text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-linkedin"
                    viewBox="0 0 16 16"
                  >
                    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                  </svg>
                </a>
                <a className="text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-instagram"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                  </svg>
                </a>
              </div>
            </div>
            <div className="col-sm-6 col-lg-2">
              <h5 className="mb-4">Company</h5>
              <ul className="list-unstyled mb-0">
                <li className="mb-2">
                  <a href="#about" className="text-white text-decoration-none">
                    About Us
                  </a>
                </li>
                <li className="mb-2">
                  <a className="text-white text-decoration-none">Our Team</a>
                </li>
                <li className="mb-2">
                  <a className="text-white text-decoration-none">Careers</a>
                </li>
                <li className="mb-2">
                  <a
                    href="#contact"
                    className="text-white text-decoration-none"
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-sm-6 col-lg-2">
              <h5 className="mb-4">Services</h5>
              <ul className="list-unstyled mb-0">
                <li className="mb-2">
                  <a
                    href="#gallery"
                    className="text-white text-decoration-none"
                  >
                    E- Commerce Website Solution
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="#gallery"
                    className="text-white text-decoration-none"
                  >
                    Application Development
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="#gallery"
                    className="text-white text-decoration-none"
                  >
                    Business Intelligence
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-4">
              <h5 className="mb-4">Newsletter</h5>
              <p className="mb-4">
                Subscribe to our newsletter to receive updates and news.
              </p>
              <form className="d-flex gap-2">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Your email"
                />
                <button type="submit" className="btn btn-primary">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
          <hr className="my-4 border-secondary" />
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              <p className="mb-0">
                &copy; {new Date().getFullYear()} ProwessERP.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <a className="text-white text-decoration-none">
                    Privacy Policy
                  </a>
                </li>
                <li className="list-inline-item ms-3">
                  <a className="text-white text-decoration-none">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </>
  );
}
